export default "__VITE_ASSET__C18k8HFB__"